module.exports = __webpack_public_path__ + "media/images/riders/small/BRENDAN_FAIRCLOUGH-f1f5fbab65857c671de1581dfbf42fcc.png";